import {
  SET_FORM,
  RESET_FORM_PAGE,
  SET_AGREE_TNC,
  SET_FORM_DATA,
} from 'redux/actions/types';

const initialState = {
  form: {},
  tnc: {
    value: {},
    isAgreed: false,
  },
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM:
      return {
        ...state,
        form: action.payload,
      };
    case SET_AGREE_TNC:
      return {
        ...state,
        tnc: {
          ...state.tnc,
          isAgreed: true,
        },
      };
    case SET_FORM_DATA:
      return {
        ...state,
        formValue: action.payload,
      };
    case RESET_FORM_PAGE:
      return initialState;
    default:
      return state;
  }
};
